import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import WhySolar from '../components/WhySolar';
import Projects from '../components/Projects';
import Partners from '../components/Partners';
import Solutions from '../components/Solutions';
import Pricing from '../components/Pricing';
import ContactForm from '../components/ContactForm';
import Press from '../components/Press';
import News from '../components/News';
import Footer from '../components/Footer';

const HomePage = () => {
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 1000,
      once: true,
      easing: 'ease-out-cubic'
    });

    // Simulate loading
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    // Scroll to top button visibility
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="home-page">
      {/* Preloader */}
      {loading && (
        <div className={`preloader ${!loading ? 'hidden' : ''}`}>
          <div className="loader"></div>
        </div>
      )}

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main>
        <Hero />
        <About />
        <WhySolar />
        <Projects />
        <Partners />
        <Solutions />
        <Pricing />
        <ContactForm />
        <Press />
        <News />
      </main>

      {/* Footer */}
      <Footer />

      {/* Scroll to Top Button */}
      <button
        className={`scroll-top ${showScrollTop ? 'visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <i className="fas fa-chevron-up"></i>
      </button>
    </div>
  );
};

export default HomePage;